export enum MessageType {
    Bot = "bot",
    Agent = "agent",
    Visitor = "visitor",
    ConversationEnded = "ConversationEnded",
    LeaveAMessage = "LeaveAMessage",
    MessageLeft = "MessageLeft",
}

export enum MessageDocType {
    Vehicle = "vehicle",
    Generic = "generic",
    Video = "video",
}

export interface Message {
    avatar?: string;
    attachments?: any[];
    type: MessageType;
    displayDate: string;
    id?: number | string;
    message?: string;
}

export type Messages = Message[];

export interface MessageData {
    total: number;
    messages: Messages;
}
